import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { SUPPORT_TICKET_REQUEST } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, DELETE, PUT } = HTTP_METHODS;
const { GET_SUPPORT_TICKETS, POST_SUPPORT_TICKET, DELETE_SUPPORT_TICKET, PUT_SUPPORT_TICKET } =
  SUPPORT_TICKET_REQUEST;

export const supportTicketApi = createApi({
  reducerPath: 'supportTicketApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getSupportTickets: builder.query({
      query: (data) => ({ url: `${GET_SUPPORT_TICKETS}${buildQueryString(data)}`, method: GET })
    }),
    addSupportTicket: builder.mutation({
      query: (data) => ({ url: POST_SUPPORT_TICKET, method: POST, data })
    }),
    deleteSupportTicket: builder.mutation({
      query: (id) => ({
        url: `${DELETE_SUPPORT_TICKET}/${id}`,
        method: DELETE
      })
    }),
    editSupportTicket: builder.mutation({
      query: (data) => ({
        url: `${PUT_SUPPORT_TICKET}/${data?.id}`,
        method: PUT,
        data: data.data
      })
    })
  })
});

export const {
  useGetSupportTicketsQuery,
  useAddSupportTicketMutation,
  useEditSupportTicketMutation,
  useDeleteSupportTicketMutation
} = supportTicketApi;
